// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19LvU","toggle":"styles_toggle__PJ6Ao","preview":"styles_preview__2gRQ4"};